import $ from "jquery";
import {
  ADD_TO_CART_EVENT,
  PROCEED_TO_CHECKOUT_EVENT,
  VIEW_CART_EVENT,
} from "../constants/AppConstants";
import { extractVariantID } from "./helpers";

/**
 * Tracks cart-related events and pushes them to the data layer.
 */
class CartEventTracker {
  /**
   * Constructs the CartEventTracker and retrieves the user's confluence ID.
   */
  constructor() {
    this.userConfluenceId = $("#user-authentication").attr("data-user-cf-id");
  }

  /**
   * Triggers an add-to-cart event.
   *
   * @param {Object} product - The product object to be added to the cart.
   */
  addToCartEvent(product) {
    if (product?.quantity > 0) {
      const formattedProduct = {
        event_label: ADD_TO_CART_EVENT,
        user_id: this.userConfluenceId,
        product_id: product?.variant?.id,
        product_name: product?.title,
        product_price: product?.variant?.priceV2?.amount,
        product_currency: product?.variant?.priceV2?.currencyCode,
        product_quantity: product?.quantity,
      };
      this._pushToDataLayer({ event: ADD_TO_CART_EVENT, ...formattedProduct });
    }
  }

  /**
   * Triggers a view-cart event.
   *
   * @param {Object} cart - The cart object containing cart details.
   */
  viewCartEvent(cart) {
    const cartInformation = {
      event_label: VIEW_CART_EVENT,
      user_id: this.userConfluenceId,
      cart_id: cart?.id,
      cart_currency: cart?.currencyCode,
      cart_subtotal: cart?.subtotalPriceV2?.amount,
      cart_tax: cart?.totalTaxV2?.amount,
      cart_total: cart?.totalPriceV2?.amount,
      cart_created_at: cart?.createdAt,
      cart_updated_at: cart?.updatedAt,
    };
    this._pushToDataLayer({ event: VIEW_CART_EVENT, ...cartInformation });
  }

  /**
   * Triggers a proceed-to-checkout event.
   *
   * @param {Object} checkoutDetails - The details of the checkout process.
   */
  proceedToCheckoutEvent(checkoutDetails) {
    const checkoutData = {
      event_label: PROCEED_TO_CHECKOUT_EVENT,
      user_id: this.userConfluenceId,
      checkout_id: checkoutDetails?.id,
      checkout_total: checkoutDetails?.totalPriceV2?.amount,
      checkout_currency: checkoutDetails?.totalPriceV2?.currencyCode,
    };
    this._pushToDataLayer({ event: PROCEED_TO_CHECKOUT_EVENT, ...checkoutData });
  }

  /**
   * Pushes event data to the data layer.
   *
   * @param {Object} eventData - The event data to push to the data layer.
   * @private
   */
  _pushToDataLayer(eventData) {
    window.dataLayer?.push(eventData);
  }
}

export default CartEventTracker;
